import React from 'react'
import '../components/Styles/home.css'
import '../components/Styles/About.css'
import '../components/Styles/contact.css'
import {Helmet}from"react-helmet";
import xm1 from '../assets/images/contact.png'
import mem1 from '../assets/images/tmember.png'
import c1 from '../assets/images/c1.png'
import c2 from '../assets/images/c2.png'
import c3 from '../assets/images/c3.png'
import c4 from '../assets/images/c4.png'
import c5 from '../assets/images/c5.png'
import c6 from '../assets/images/c6.png'
import c7 from '../assets/images/c7.png'

const Contact = () => {
  const IconCalendar = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M7 3v3M17 3v3M4.5 8.5h15"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
    <path
      d="M6 5h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2z"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinejoin="round"
    />
    <path
      d="M8 12h3M8 15h3M14 12h2"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);

/* renamed to avoid conflict with IconPhone above */
const IconCall = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M7 3h4l2 5-2 1c1 2.8 3.2 5 6 6l1-2 5 2v4c0 1-1 2-2 2C10 21 3 14 3 5c0-1 1-2 2-2h2z"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinejoin="round"
    />
  </svg>
);
  return (
    <div>
              <Helmet>
      
      <title>Contact Us - Premium Co-Working Spaces in Houston - Xceed Office</title>
      <meta name="description" content="Get in touch with Xceed offices today to explore our modern co-working spaces in Houston. Our flexible workspaces are designed to inspire productivity and collaboration."/>
      < meta name="viewport" content="width=device-width, initial-scale=1.0"/>
      <meta charset="UTF-8"/>
      
      </Helmet>

 <section className="conversation">
  <div className="conversation__container">

    <p className="conversation__kicker">
      <span></span> CONTACT
    </p>

    <h2 className="conversation__title">
      Let's Start a <span>Conversation</span>
    </h2>

    <p className="conversation__text">
      Whether you're ready to tour our facilities or exploring workspace
      options, our team is here to help you make the right decision.
    </p>

  </div>
</section>
<section  className="contactCards">

  <div className="contactCards__container">

    <div className="contactCards__grid">

      {/* Card 1 */}
      <div className="contactCard">
        <div className="contactCard__icon"><img src={c1} alt="" /> </div>
        <p className="contactCard__label">CALL US</p>
        <h3>+1 (281) 270-6431</h3>
        <span>Mon–Fri 8am–6pm CST</span>
      </div>

      {/* Card 2 */}
      <div className="contactCard">
        <div className="contactCard__icon"><img src={c2} alt="" /></div>
        <p className="contactCard__label">EMAIL US</p>
        <h3>info@xceedoffice.com</h3>
        <span>We respond within 2 hours</span>
      </div>

    

   
    </div>

  </div>

</section>
<section style={{background:"#171717ff"}} className="msg">
  <div className="msg__container">

    {/* Header */}
    <header className="msg__header">
      <p className="msg__kicker">GET IN TOUCH</p>
      <h2 className="msg__title">
        Send Us a <span>Message</span>
      </h2>
    </header>

    <div className="msg__grid">

      {/* LEFT: FORM CARD */}
      <div className="msgForm">
        <form className="msgForm__form">

          <div className="msgForm__row">
            <div className="msgField">
              <label>First Name</label>
              <input type="text" placeholder="John" />
            </div>

            <div className="msgField">
              <label>Last Name</label>
              <input type="text" placeholder="Smith" />
            </div>
          </div>

          <div className="msgField">
            <label>Business Email</label>
            <input type="email" placeholder="john@company.com" />
          </div>

          <div className="msgField">
            <label>Phone Number</label>
            <input type="tel" placeholder="(555) 000-0000" />
          </div>

          <div className="msgField">
            <label>I’m Interested In</label>
            <select defaultValue="">
              <option value="" disabled>Select an option</option>
              <option>Private Offices</option>
              <option>Virtual Office</option>
              <option>Meeting Rooms</option>
              <option>Day Offices</option>
            </select>
          </div>

          <div className="msgField">
            <label>Message</label>
            <textarea rows="4" placeholder="Tell us about your workspace needs..." />
          </div>

          <button type="submit" className="msgForm__btn">
            <span className="msgForm__btnIcon"></span>
            Send Message <span className="msgForm__btnArrow">→</span>
          </button>

        </form>
      </div>

      {/* RIGHT: MAP + IMAGE CARDS */}
      <div className="msgSide">

        <div className="msgMapCard">
          <iframe
            title="3050 Post Oak Blvd"
            className="msgMapCard__map"
            src="https://www.google.com/maps?q=3050+Post+Oak+Blvd+Houston+TX+77056&output=embed"
            loading="lazy"
          />
        </div>

        {/* You said you have bg pic — add it in CSS or inline style */}
        <div className="msgLocCard">
          <div className="msgLocCard__overlay">
            <div className="msgLocCard__pin">📍</div>

            <p className="msgLocCard__line">
              3050 Post Oak Blvd, Suite 300
            </p>
            <p className="msgLocCard__sub">
              Uptown Houston • Galleria Area
            </p>
          </div>
        </div>

      </div>

    </div>
  </div>
</section>
<section className="reach">
  <div className="reach__container">

    <div className="reach__header">
      <p className="reach__kicker">HOW WE HELP</p>
      <h2 className="reach__title">
        Why Reach <span>Out</span>
      </h2>
    </div>

    <div className="reach__grid">

      {/* Card 1 */}
      <div className="reachCard">
        <div className="reachCard__icon"><img src={c5} alt="" /></div>
        <h3>Tour Our Facilities</h3>
        <p>
          Walk through our Class-A workspace and experience the
          Xceed difference firsthand.
        </p>
      </div>

      {/* Card 2 */}
      <div className="reachCard">
        <div className="reachCard__icon"><img src={c6} alt="" /></div>
        <h3>Explore Office Solutions</h3>
        <p>
          From virtual presence to private suites —
          find the plan that fits your business.
        </p>
      </div>

      {/* Card 3 */}
      <div className="reachCard">
        <div className="reachCard__icon"><img src={c7} alt="" /></div>
        <h3>Custom Requirements</h3>
        <p>
          Need something tailored? Our team will design
          a solution around your needs.
        </p>
      </div>

    </div>

  </div>
</section>
 <section  className="cta">
        <div className="cta__wrap">
          <h2 className="cta__title">
            Ready to Elevate Your <br />
            <span>Business Presence?</span>
          </h2>

          <p className="cta__sub">
            Join professionals who trust Xceed Office for their workspace <br />
            needs.
          </p>

          <div className="cta__actions">
            <button className="cta__btn cta__btn--primary" type="button">
              <span className="cta__btnIcon"><IconCalendar /></span>
                            <a href="https://calendly.com/xceedoffice-info/new-meeting?month=2026-03">Schedule a Tour</a> <span className="cta__arrow">→</span>
            </button>

            <button className="cta__btn cta__btn--ghost" type="button">
              <span className="cta__btnIcon"><IconCall /></span>
              Call Now
            </button>
          </div>

        
        </div>
      </section>

    </div>
  )
}

export default Contact